import { Component, DOCUMENT, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Footer } from './shared/components/footer/footer';
import { Header } from './shared/components/header/header';
import { SideMenu } from './shared/components/side-menu/side-menu';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';
import { SeoService } from './shared/services/seo.service';

const GTM_ID = 'GTM-5LPGMCQ';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SideMenu, Header, Footer, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected show = false;
  protected title = 'semnexus-landing';

  private isBrowser: boolean = false;
  private isPopState = false;

  constructor(
    private router: Router,
    private seo: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    // Emit Organization + WebSite JSON-LD on every render (SSR + browser).
    // These are global "knowledge graph" signals used by Google for the
    // search-result site card and entity disambiguation.
    this.seo.setGlobalSchemas();

    if (this.isBrowser) {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          // Push virtual page_view to GTM dataLayer so GA4 sees SPA navigations.
          // Without this, only the initial document load fires page_view and
          // every route change after looks like a "session bounce" to GA.
          (window as any).dataLayer = (window as any).dataLayer || [];
          (window as any).dataLayer.push({
            event: 'page_view',
            page_path: event.urlAfterRedirects,
            page_location: window.location.href,
            page_title: document.title,
          });

          // OpenAI/ChatGPT Ads pixel: page_viewed must be fired manually (init does
          // NOT auto-fire it) and requires a data object ({ type: 'contents' }). Fire
          // on every NavigationEnd — the initial navigation is the landing page view,
          // subsequent ones are SPA route changes. The oaiq queue stub buffers calls
          // made before the async SDK finishes loading.
          (window as any).oaiq?.('measure', 'page_viewed', { type: 'contents' });

          // Meta Pixel: PageView on initial load and every SPA route change.
          // The base pixel (init) is loaded from index.html; here we fire the
          // browser-side PageView. (No CAPI for PageView — CAPI is reserved for
          // the Lead/Schedule conversions in analytics.service.ts.)
          (window as any).fbq?.('track', 'PageView');

          if (!this.isPopState) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
    }
  }

  scroll(lock: boolean) {
    if (this.isBrowser) {
      document.body.classList.toggle('overflow-hidden', lock);
    }
  }
}
